module.exports = __webpack_public_path__ + "static/media/image_processing_ca_1.32924541.png";